import { render, staticRenderFns } from "./listacatalogo.vue?vue&type=template&id=2ca56bd9&scoped=true"
import script from "./listacatalogo.vue?vue&type=script&lang=js"
export * from "./listacatalogo.vue?vue&type=script&lang=js"
import style0 from "./listacatalogo.vue?vue&type=style&index=0&id=2ca56bd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca56bd9",
  null
  
)

export default component.exports